import Status from "./Status";
import Remap from "./Remap";
import CustomerView from "./CustomerView";

export default function SystemActions({ system }: { system: CoreSystem }) {
    return (
        <div>
            <h5 className="mb-2 text-xl font-medium ">System</h5>

            <hr className="border-t border-muted mb-4" />

            <div className="flex justify-start gap-2">
                <Status system={system} />
                <Remap system={system} />
                <CustomerView system={system} />
            </div>
        </div>
    );
}
